import api from "@/api"
const state = {
  partnerLogos: []
}
const actions = {
  getPartnerLogos({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.partner.partnerLogos(params).then(
        (response) => {
          commit("setPartnerLogos", response.data.data || [])
          resolve(response.data.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  addPartnerLogo({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.addPartnerLogo(payloads).then(
        (response) => {
          resolve(response.data.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  changePartnerLogo({ _ }, { id, payloads }) {
    return new Promise((resolve, reject) => {
      api.partner.changePartnerLogo(id, payloads).then(
        (response) => {
          resolve(response.data.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  },
  deletePartnerLogo({ _ }, { id }) {
    return new Promise((resolve, reject) => {
      api.partner.deletePartnerLogo(id).then(
        (response) => {
          resolve(response.data.data)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setPartnerLogos(state, value) {
    state.partnerLogos = value
  }
}
const getters = {
  partnerLogos: (state) => state.partnerLogos
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
